import React from 'react'
import { Card, DatePicker, Button, Row, Col } from 'antd'
import { ClearOutlined } from '@ant-design/icons'
import type { State } from '../types'
import { OuterTableTextFilter } from '../../../components/table-filters/outer-text'
import dayjs from 'dayjs'
import type { Dayjs } from 'dayjs'

const { RangePicker } = DatePicker

interface FiltersProps {
  dateRange: State['filters']['dateRange']
  searchQuery?: string
  onDateRangeChange: (dateRange: { from?: string; to?: string }) => void
  onSearchChange: (query: string | undefined) => void
  onClear: () => void
  loading?: boolean
}

export const Filters: React.FC<FiltersProps> = ({
  dateRange,
  searchQuery,
  onDateRangeChange,
  onSearchChange,
  onClear,
  loading = false
}) => {
  const handleDateRangeChange = (dates: (Dayjs | null)[] | null) => {
    if (dates && dates.length === 2) {
      onDateRangeChange({
        from: dates[0]!.format('YYYY-MM-DD'),
        to: dates[1]!.format('YYYY-MM-DD')
      })
    } else {
      onDateRangeChange({})
    }
  }

  const handleSearchClear = () => {
    onSearchChange(undefined)
  }

  const dateRangeValue: [dayjs.Dayjs, dayjs.Dayjs] | null =
    dateRange.from && dateRange.to ? [dayjs(dateRange.from), dayjs(dateRange.to)] : null

  return (
    <Card title='Filters' size='small' style={{ marginBottom: 16 }}>
      <Row gutter={16} align='bottom'>
        <Col span={8}>
          <div style={{ marginBottom: 8 }}>
            <label style={{ fontSize: '14px', fontWeight: 500 }}>Search</label>
          </div>
          <OuterTableTextFilter
            placeholder='Search by EOB number, filename, or URL'
            defaultValue={searchQuery}
            onSearch={onSearchChange}
            onClear={handleSearchClear}
          />
        </Col>

        <Col span={6}>
          <div style={{ marginBottom: 8 }}>
            <label style={{ fontSize: '14px', fontWeight: 500 }}>Date Range</label>
          </div>
          <RangePicker
            style={{ width: '100%' }}
            format='DD.MM.YYYY'
            placeholder={['From', 'To']}
            value={dateRangeValue}
            onChange={handleDateRangeChange}
            disabled={loading}
          />
        </Col>

        <Col span={4}>
          <Button type='default' icon={<ClearOutlined />} onClick={onClear} disabled={loading}>
            Clear All
          </Button>
        </Col>
      </Row>
    </Card>
  )
}
